/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type MetadataAccountForMintInput = {
    mint: unknown;
};
export type NftPageQueryVariables = {
    input: MetadataAccountForMintInput;
};
export type NftPageQueryResponse = {
    readonly metadataAccountForMint: {
        readonly id: string;
        readonly offchainData: {
            readonly image: string;
        };
        readonly tags: ReadonlyArray<string>;
        readonly " $fragmentRefs": FragmentRefs<"NftInfo_MetadataAccount" | "NftTags_MetadataAccount">;
    } | null;
};
export type NftPageQuery = {
    readonly response: NftPageQueryResponse;
    readonly variables: NftPageQueryVariables;
};



/*
query NftPageQuery(
  $input: MetadataAccountForMintInput!
) {
  metadataAccountForMint(input: $input) {
    id
    offchainData {
      image
    }
    tags
    ...NftInfo_MetadataAccount
    ...NftTags_MetadataAccount
  }
}

fragment ArtistPillButtonForUser_User on User {
  id
  username
  ProfilePhoto {
    id
    photoUrl
  }
}

fragment BidButton_MetadataAccount on MetadataAccount {
  id
  ...BidModal_MetadataAccount
}

fragment BidModal_MetadataAccount on MetadataAccount {
  id
  mint
  nft {
    creatorId
    price
    ownerId
    status
    Creator {
      id
    }
    Owner {
      id
    }
  }
  ...ListingCardForMetadata_MetadataAccount
}

fragment CancelListingModal_MetadataAccount on MetadataAccount {
  id
  mint
  nft {
    creatorId
    price
  }
}

fragment ChangePriceModal_MetadataAccount on MetadataAccount {
  id
  mint
  nft {
    creatorId
  }
}

fragment EditTagsModal_MetadataAccount on MetadataAccount {
  id
  mint
  tags
}

fragment ListNftButton_MetadataAccount on MetadataAccount {
  id
  ...ListNftModal_MetadataAccount
}

fragment ListNftModal_MetadataAccount on MetadataAccount {
  id
  mint
  nft {
    creatorId
  }
  tags
}

fragment ListingCardForMetadata_MetadataAccount on MetadataAccount {
  id
  mint
  data {
    name
  }
  offchainData {
    image
  }
  nft {
    creatorId
    Creator {
      username
      ...ArtistPillButtonForUser_User
    }
  }
  ...NftOtherInfo_MetadataAccount
}

fragment NftActionButton_MetadataAccount on MetadataAccount {
  id
  nft {
    id
    isOffPlatform
    ownerId
    status
  }
  ...BidButton_MetadataAccount
  ...ListNftButton_MetadataAccount
}

fragment NftEllipsisShadowButton_MetadataAccount on MetadataAccount {
  id
  ...EditTagsModal_MetadataAccount
  ...CancelListingModal_MetadataAccount
  ...ChangePriceModal_MetadataAccount
}

fragment NftInfo_MetadataAccount on MetadataAccount {
  id
  mint
  nft {
    id
    creatorId
    isOffPlatform
    price
    Creator {
      id
      username
      ProfilePhoto {
        id
        photoUrl
      }
    }
    Owner {
      id
      username
      ProfilePhoto {
        id
        photoUrl
      }
    }
    ownerId
    status
  }
  data {
    name
  }
  offchainData {
    description
    image
  }
  ...NftEllipsisShadowButton_MetadataAccount
  ...NftPrice_MetadataAccount
  ...NftActionButton_MetadataAccount
}

fragment NftOtherInfo_MetadataAccount on MetadataAccount {
  id
  nft {
    id
    isOffPlatform
    price
    status
  }
}

fragment NftPrice_MetadataAccount on MetadataAccount {
  id
  nft {
    id
    price
    status
  }
}

fragment NftTags_MetadataAccount on MetadataAccount {
  tags
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tags",
  "storageKey": null
},
v5 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "username",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Photo",
    "kind": "LinkedField",
    "name": "ProfilePhoto",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "photoUrl",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NftPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MetadataAccount",
        "kind": "LinkedField",
        "name": "metadataAccountForMint",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MetadataOffchain",
            "kind": "LinkedField",
            "name": "offchainData",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "NftInfo_MetadataAccount"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "NftTags_MetadataAccount"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NftPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MetadataAccount",
        "kind": "LinkedField",
        "name": "metadataAccountForMint",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MetadataOffchain",
            "kind": "LinkedField",
            "name": "offchainData",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "mint",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NftExpress",
            "kind": "LinkedField",
            "name": "nft",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "creatorId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isOffPlatform",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "price",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "Creator",
                "plural": false,
                "selections": (v5/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "Owner",
                "plural": false,
                "selections": (v5/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ownerId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MetadataAccountData",
            "kind": "LinkedField",
            "name": "data",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "be8839ea267281fbe1d1ac00aceeec36",
    "id": null,
    "metadata": {},
    "name": "NftPageQuery",
    "operationKind": "query",
    "text": "query NftPageQuery(\n  $input: MetadataAccountForMintInput!\n) {\n  metadataAccountForMint(input: $input) {\n    id\n    offchainData {\n      image\n    }\n    tags\n    ...NftInfo_MetadataAccount\n    ...NftTags_MetadataAccount\n  }\n}\n\nfragment ArtistPillButtonForUser_User on User {\n  id\n  username\n  ProfilePhoto {\n    id\n    photoUrl\n  }\n}\n\nfragment BidButton_MetadataAccount on MetadataAccount {\n  id\n  ...BidModal_MetadataAccount\n}\n\nfragment BidModal_MetadataAccount on MetadataAccount {\n  id\n  mint\n  nft {\n    creatorId\n    price\n    ownerId\n    status\n    Creator {\n      id\n    }\n    Owner {\n      id\n    }\n  }\n  ...ListingCardForMetadata_MetadataAccount\n}\n\nfragment CancelListingModal_MetadataAccount on MetadataAccount {\n  id\n  mint\n  nft {\n    creatorId\n    price\n  }\n}\n\nfragment ChangePriceModal_MetadataAccount on MetadataAccount {\n  id\n  mint\n  nft {\n    creatorId\n  }\n}\n\nfragment EditTagsModal_MetadataAccount on MetadataAccount {\n  id\n  mint\n  tags\n}\n\nfragment ListNftButton_MetadataAccount on MetadataAccount {\n  id\n  ...ListNftModal_MetadataAccount\n}\n\nfragment ListNftModal_MetadataAccount on MetadataAccount {\n  id\n  mint\n  nft {\n    creatorId\n  }\n  tags\n}\n\nfragment ListingCardForMetadata_MetadataAccount on MetadataAccount {\n  id\n  mint\n  data {\n    name\n  }\n  offchainData {\n    image\n  }\n  nft {\n    creatorId\n    Creator {\n      username\n      ...ArtistPillButtonForUser_User\n    }\n  }\n  ...NftOtherInfo_MetadataAccount\n}\n\nfragment NftActionButton_MetadataAccount on MetadataAccount {\n  id\n  nft {\n    id\n    isOffPlatform\n    ownerId\n    status\n  }\n  ...BidButton_MetadataAccount\n  ...ListNftButton_MetadataAccount\n}\n\nfragment NftEllipsisShadowButton_MetadataAccount on MetadataAccount {\n  id\n  ...EditTagsModal_MetadataAccount\n  ...CancelListingModal_MetadataAccount\n  ...ChangePriceModal_MetadataAccount\n}\n\nfragment NftInfo_MetadataAccount on MetadataAccount {\n  id\n  mint\n  nft {\n    id\n    creatorId\n    isOffPlatform\n    price\n    Creator {\n      id\n      username\n      ProfilePhoto {\n        id\n        photoUrl\n      }\n    }\n    Owner {\n      id\n      username\n      ProfilePhoto {\n        id\n        photoUrl\n      }\n    }\n    ownerId\n    status\n  }\n  data {\n    name\n  }\n  offchainData {\n    description\n    image\n  }\n  ...NftEllipsisShadowButton_MetadataAccount\n  ...NftPrice_MetadataAccount\n  ...NftActionButton_MetadataAccount\n}\n\nfragment NftOtherInfo_MetadataAccount on MetadataAccount {\n  id\n  nft {\n    id\n    isOffPlatform\n    price\n    status\n  }\n}\n\nfragment NftPrice_MetadataAccount on MetadataAccount {\n  id\n  nft {\n    id\n    price\n    status\n  }\n}\n\nfragment NftTags_MetadataAccount on MetadataAccount {\n  tags\n}\n"
  }
};
})();
(node as any).hash = '604e12119b3915ca6aca01b855cbe928';
export default node;
